import React from 'react'
import { employmentRelationshipTypes } from 'utils/constants/DueDiligenceRelations'
import { formatInBrazilianDate } from 'utils/functions'

import styles from './styles'
import AttachmentsList from "../../../AttachmentsList"
import DisplayAnswerItems from './DisplayAnswerItems'

function DisplayExternalActivities(props) {
  const { questionData } = props
  const classes = styles()
  const buildXpOfficeBondInfo = (answer) => {
    return (
      <React.Fragment>
        <h3>Vínculo com o escritório XP:</h3>
        <div className={classes.answersContainer}>
          <p>
            <span>Vínculo com o escritório será de celetista (CLT) ou assessor terceirizado? </span>
            {answer.is_clt_employee_or_third_party_advisor ? "Sim" : "Não"}
          </p>
          {
            answer.employment_document_attachments && answer.employment_document_attachments.length > 0 && (
              <AttachmentsList
                attachments={answer.employment_document_attachments}
                title="Carteira de trabalho (CLT) ou contrato de trabalho (assessor terceirizado):"
              />
            )
          }
        </div>
      </React.Fragment>
    )
  }

  const buildExternalActivity = (occupationInfo) => {
    return (
      <div className={classes.answersContainer} key={occupationInfo.key}>
        <p>
          <span>Tipos de Vínculo: </span>
          {occupationInfo.bond_type === 'other'
            ? occupationInfo.bond_informed_as_other
            : employmentRelationshipTypes[occupationInfo.bond_type]}
        </p>
        <p>
          <span>Cargo: </span>
          {occupationInfo.role}
        </p>

        <p>
          <span>Atividades desempenhadas: </span>
          {occupationInfo.developed_activities}
        </p>
        <p>
          <span>Reporta/reportava-se a: </span>
          {occupationInfo.reports_to}
        </p>
        {occupationInfo.end_of_contract ? (
          <p>
            <span>Fim do vínculo: </span>
            {formatInBrazilianDate(occupationInfo.end_of_contract)}
          </p>
        ) : null}

        {occupationInfo.currently_at_this_job ? (
          <p>
            <span>Jornada de trabalho: </span>
            {` ${occupationInfo.start_working_hours} às ${occupationInfo.end_working_hours}.`}
          </p>
        ) : null}
        <p>
          <span>Jornada da atividade de assessoria: </span>
          {` ${occupationInfo.investment_advisory_start_time} às ${occupationInfo.investment_advisory_end_time}.`}
        </p>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <h3>Vínculos externos:</h3>

      <DisplayAnswerItems
        answerData={questionData}
        noDataMessage="O assessor informou que não possui vínculo empregatício com outras empresas públicas ou privadas."
        funcBuildItem={buildExternalActivity}
      />
      
      {
        questionData.answer && buildXpOfficeBondInfo(questionData.answer)
      }
    </div>
  )
}

export default DisplayExternalActivities
